import { useTranslation } from 'react-i18next';
import * as S from './styles';
import { Row } from '@/styles/reactnative';
import { COLORS } from '@/app/constants';
import { Tab, tabs } from '../useTab';

interface TabContainerProps {
  isActive: (tab: Tab) => boolean;
  setCurrentTab: (tab: Tab) => void;
}

const TabContainer = ({ isActive, setCurrentTab }: TabContainerProps) => {
  const { t } = useTranslation();

  return (
    <S.Container>
      {tabs.map((tab) => {
        return (
          <S.Tab
            key={tab}
            isActive={isActive(tab)}
            onClick={() => setCurrentTab(tab)}
          >
            <Row style={{ gap: '10px', alignItems: 'center' }}>
              {isActive(tab) && (
                <svg
                  width="27"
                  height="26"
                  viewBox="0 0 27 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6945 14.0595L15.7934 15.4749C14.1671 16.2636 12.9045 17.6515 12.2717 19.3451L10.6271 23.7136C10.569 23.8694 10.4467 23.9917 10.2908 24.0528C9.99122 24.1629 9.65495 24.0131 9.54185 23.7136L7.90024 19.3451C7.26438 17.6546 6.0049 16.2759 4.37857 15.4871L1.47748 14.0748C1.36132 14.0167 1.26655 13.922 1.20847 13.8058C1.06784 13.5154 1.19012 13.1699 1.47748 13.0293L4.37857 11.617C6.00796 10.8283 7.26744 9.44041 7.90024 7.74682L9.54491 3.37839C9.60299 3.25913 9.7008 3.16132 9.82003 3.10322C10.1196 2.95649 10.4803 3.07881 10.6301 3.37839L12.2748 7.73768C12.9045 9.43429 14.1671 10.8191 15.7934 11.6109L18.6945 13.0201C18.8963 13.1179 19.0216 13.3228 19.0216 13.546C19.0185 13.7661 18.8932 13.9647 18.6945 14.0595Z"
                    fill={COLORS.primary}
                  />
                  <path
                    d="M25.6643 6.1945L24.5931 6.71715C24.0185 6.99579 23.5737 7.48384 23.3487 8.0809L22.743 9.69558C22.7084 9.78385 22.6392 9.85307 22.5509 9.88595C22.3813 9.95 22.1927 9.8652 22.1286 9.69558L21.5212 8.0809C21.2979 7.48384 20.8514 6.99579 20.2769 6.71715L19.2056 6.1945C19.1398 6.16334 19.0862 6.1097 19.055 6.04393C18.9754 5.87953 19.0429 5.68395 19.2056 5.60434L20.2769 5.08169C20.8514 4.80308 21.2979 4.31502 21.5212 3.71623L22.1286 2.10326C22.1615 2.03405 22.2169 1.98039 22.2844 1.94579C22.454 1.86272 22.6582 1.93366 22.743 2.10326L23.3487 3.71623C23.5737 4.31502 24.0185 4.80308 24.5931 5.08169L25.6643 5.60434C25.7301 5.6355 25.7838 5.68914 25.8166 5.75493C25.8963 5.9176 25.8288 6.11489 25.6643 6.1945Z"
                    fill={COLORS.primary}
                  />
                </svg>
              )}
              <span>{t(tab)}</span>
            </Row>
            {isActive(tab) && <S.TabLayout />}
          </S.Tab>
        );
      })}
    </S.Container>
  );
};

export default TabContainer;
